import React, { useEffect, useState } from "react";
import WOW from "wow.js";

function AboutOne() {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_BASE_URL = (
    process.env.REACT_APP_API_BASE_URL ||
    "http://localhost:5000"
  ).replace(/\/+$/, "");

  /*
   * API'den:
   * /hakkimizda-aboutImage-cropped-....webp
   *
   * şeklinde gelen görseli:
   * http://localhost:5000/cdn/hakkimizda-aboutImage-cropped-....webp
   *
   * şekline çevirir.
   */
  const getImageUrl = (imagePath) => {
    if (!imagePath || typeof imagePath !== "string") {
      return "";
    }

    const trimmedPath = imagePath.trim();

    if (
      trimmedPath.startsWith("http://") ||
      trimmedPath.startsWith("https://") ||
      trimmedPath.startsWith("data:") ||
      trimmedPath.startsWith("blob:")
    ) {
      return trimmedPath;
    }

    const cleanPath = trimmedPath.replace(/^\/+/, "");

    return `${API_BASE_URL}/cdn/${cleanPath}`;
  };

  /*
   * Hakkımızda verisini veritabanından çek
   */
  useEffect(() => {
    const controller = new AbortController();

    const fetchAboutData = async () => {
      try {
        setLoading(true);

        const searchParams = new URLSearchParams(
          window.location.search
        );

        const currentLang =
          searchParams.get("lang") || "tr";

        const response = await fetch(
          `${API_BASE_URL}/api/about/about?lang=${encodeURIComponent(
            currentLang
          )}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          }
        );

        if (!response.ok) {
          throw new Error(
            `Hakkımızda verisi alınamadı: ${response.status}`
          );
        }

        const data = await response.json();

        setAboutData(data || null);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("ABOUT_API_ERROR:", error);
          setAboutData(null);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchAboutData();

    return () => {
      controller.abort();
    };
  }, [API_BASE_URL]);

  /*
   * WOW animasyonlarını başlat
   */
  useEffect(() => {
    if (!aboutData) {
      return;
    }

    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });

    wow.init();
  }, [aboutData]);

  /*
   * Veri yüklenirken alanı boş bırak
   */
  if (loading) {
    return null;
  }

  /*
   * Backend null döndürürse bölüm görünmesin
   */
  if (!aboutData) {
    return null;
  }

  const aboutImage = getImageUrl(
    aboutData.aboutImage
  );

  return (
    <div>
      <style>
        {`
          .demirsan-about .about-description {
            margin-bottom: 18px;

            color: #333333;

            font-size: 17px;
            line-height: 1.9;
            text-align: justify;
          }

          /*
           * Editörden gelen gereksiz dış boşlukları temizle
           */
          .demirsan-about-editor,
          .demirsan-about-editor .column-1-1 {
            width: 100%;
          }

          .demirsan-about-editor > div:first-child {
            margin-top: 0;
          }

          .demirsan-about-editor > div:last-child,
          .demirsan-about-editor p:last-child {
            margin-bottom: 0;
          }

          /*
           * Sağdaki fabrika görseli
           */
          .demirsan-about .factory-image {
            width: 100%;

            overflow: hidden;

            background: #f5f5f5;

            border-radius: 10px;

            box-shadow:
              0 10px 30px rgba(0, 0, 0, 0.1);
          }

          .demirsan-about .factory-image img {
            display: block;

            width: 100%;
            height: 430px;

            object-fit: cover;
            object-position: center;
          }

          /*
           * Hakkımızda başlık alanı
           */
          .demirsan-about-title {
            position: relative;

            margin-bottom: 30px;
          }

          .demirsan-about-title::before,
          .demirsan-about-title::after {
            display: none !important;
            content: none !important;
          }

          /*
           * mainTitle alanı
           */
          .demirsan-about-subtitle {
            margin: 0 0 12px;
            padding: 0;

            color: #df0a0a;

            font-size: 16px;
            font-weight: 500;
            line-height: 1.4;
            text-transform: uppercase;
          }

          /*
           * Editor içerisindeki ana başlık
           */
          .demirsan-about-heading {
            margin: 0;

            color: #1c2539;

            font-size: 48px;
            font-weight: 700;
            line-height: 1.2;
          }

          /*
           * Editörden gelen başlık alanı
           */
          .demirsan-about-editor
            .demirsan-about-title {
            margin-bottom: 30px;
          }

          .demirsan-about-editor
            .about-inner {
            width: 100%;
          }

          @media (max-width: 991px) {
            .demirsan-about .factory-image {
              margin-bottom: 30px;
            }

            .demirsan-about .factory-image img {
              height: auto;
              min-height: 340px;
            }

            .demirsan-about
              .about-description {
              text-align: left;
            }
          }

          @media (max-width: 767px) {
            .demirsan-about-heading {
              font-size: 34px;
            }

            .demirsan-about-subtitle {
              font-size: 14px;
            }

            .demirsan-about
              .about-description {
              font-size: 15px;
              line-height: 1.75;
            }

            .demirsan-about
              .factory-image img {
              min-height: 260px;
            }
          }
        `}
      </style>

      <div className="rts-about-area rts-section-gap demirsan-about">
        <div className="container">
          <div className="row g-5 align-items-center">
            {/* SOL İÇERİK */}
            <div className="col-lg-6 col-md-12 order-lg-1 order-2">
          
                <p className="demirsan-about-subtitle">
                 Hakkımızda
                </p>
            

              {aboutData.editor && (
                <div
                  className="demirsan-about-editor"
                  dangerouslySetInnerHTML={{
                    __html: aboutData.editor,
                  }}
                />
              )}
            </div>

            {/* SAĞ GÖRSEL */}
            <div className="col-lg-6 col-md-12 order-lg-2 order-1">
              {aboutImage && (
                <div
                  className="factory-image wow fadeInRight"
                  data-wow-delay=".2s"
                >
                  <img
                    src={aboutImage}
                    alt={
                      aboutData.mainTitle ||
                      "Demirsan fabrikası"
                    }
                    loading="lazy"
                    onError={(event) => {
                      console.error(
                        "HAKKIMIZDA_GORSELI_YUKLENEMEDI:",
                        event.currentTarget.src
                      );
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutOne;